import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/analytics'
import 'firebase/auth'
import router from './router'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import pdfvuer from 'pdfvuer'
import vueFullscreen from 'vue-fullscreen'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueMoment, {
  moment,
})
Vue.use(pdfvuer)
Vue.use(vueFullscreen)

firebase.initializeApp({
  apiKey: "AIzaSyBNWhhRO7Les3KUysfb6_kQHl90tT0vJx0",
  authDomain: "the-island-epaper.firebaseapp.com",
  databaseURL: "https://the-island-epaper.firebaseio.com",
  projectId: "the-island-epaper",
  storageBucket: "the-island-epaper.appspot.com",
  messagingSenderId: "398807485829",
  appId: "1:398807485829:web:54c7a140c7ce6a888648ec",
  measurementId: "G-8TRBER9TXT"
})
firebase.analytics()
export const db = firebase.firestore()

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
})

Vue.mixin({
  data: function () {
    return {
      get apibase() {
        //return "http://127.0.0.1:3000";
        return 'http://203.143.21.233:3000'
      }
    }
  }
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
